export default [
	{
		path: "/pros/money",
		exact: true,
		policy: "providerAuth",
		component: "Money",
		mui: true,
	},
];
